import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { getAuth } from "../../redux/reducers/loginData";
import { USERS, GUEST, ADDRESS } from "utils/helper/Enum";
import { useDispatch, useSelector } from "react-redux";
import { changeLoader } from "../../redux/reducers/loader";
import { setSnackbar } from "../../redux/reducers/snackbar";
import { globalRequest } from "../../utils/global/globalRequest";
import * as CUSTOM from "../../utils/helper/custom";
import { changeTrigger } from "redux/reducers/trigger";
import {
  Button,
  Img,
  Input,
  Line,
  MobileInput,
  Text,
  AutoFillAddress,
} from "components";
import {
  validateForm,
  strFormat,
  defaultAddressParams,
  isValidMobile,
} from "../../utils/helper/custom";
import {
  updateMyAddress,
  getAddressData,
} from "../../redux/reducers/myAddress";
import {
  addDeleteGetLocalStorage,
  storageKeys,
} from "../../utils/global/localData";
import { useAppFont } from "utils/helper/useAppFont";

const AddEditAddress = (props) => {
  const { setAddAddressPopup, pageName, orderData, isInlineMode = false } = props;
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const auth = useSelector(getAuth);
  const getAddress = useSelector(getAddressData);
  const [errors, setErrors] = useState({});
  const { interClass, interFamily, headingClass, headingFamily} = useAppFont();

  const closepopupout = (type = "") => {
    if (pageName == "myAddress" || pageName == "topHeader") {
      document.body.classList.remove("overflow-hidden");
    }
    if (type == "noAction") {
      setAddAddressPopup(false);
      return;
    }
    dispatch(changeTrigger("closepopup"));
    setTimeout(() => {
      dispatch(changeTrigger("loadAddressList"));
      setAddAddressPopup(false);
    }, 1000);
  };

  const handleImageChange = (e) => {
    e.preventDefault();
    let file = e.target.files[0];

    // Extension check
    let imageError = CUSTOM.checkFileExtention(file?.name, "png|jpg|jpeg", "", "");
    if (imageError) {
      dispatch(
        setSnackbar({
          snackbarOpen: true,
          snackbarMessage: imageError,
          snackbarState: "error",
        })
      );
      e.target.value = "";
      return false;
    }

    // Size check — 100KB limit
    const maxSizeInBytes = 100 * 1024;
    if (file.size > maxSizeInBytes) {
      dispatch(
        setSnackbar({
          snackbarOpen: true,
          snackbarMessage: "Image size must be 100KB or less",
          snackbarState: "error",
        })
      );
      e.target.value = "";
      return false;
    }

    let reader = new FileReader();
    reader.onloadend = () => {
      uploadImageToServer(reader.result);
    };
    if (file) {
      reader.readAsDataURL(file);
    }
    e.target.value = "";
  };

  const uploadImageToServer = async (base64Image) => {
    try {
      dispatch(changeLoader(true));
      let response = await globalRequest(
        USERS.UPLOAD_ADDRESS_IMAGE,
        "post",
        { image: base64Image },
        {},
        true
      );
      response = response?.data;
      dispatch(changeLoader(false));

      if (response?.status == "SUCCESS") {
        dispatch(
          updateMyAddress({
            ...getAddress,
            image_link: response?.data,
          })
        );
      } else {
        dispatch(
          setSnackbar({
            snackbarOpen: true,
            snackbarMessage: response?.message,
            snackbarState: "error",
          })
        );
      }
    } catch (e) {
      dispatch(changeLoader(false));
      dispatch(
        setSnackbar({
          snackbarOpen: true,
          snackbarMessage: e?.message,
          snackbarState: "error",
        })
      );
    }
  };

  /**
   *  Add or update user Address
   */
  const saveAddress = async (e) => {
    e.preventDefault();
    let validationErrors = validateForm(getAddress, "addAddressDetails", t, auth?.id);
    let validateMobile = isValidMobile(getAddress?.mobile_no, t);
    validationErrors = { ...validationErrors, ...validateMobile };
    if (!getAddress?.addressDetails || getAddress.addressDetails.trim() === "") {
      validationErrors = {
        ...validationErrors,
        addressDetails: t("pleaseEnterAddressLabel") || "Please enter address label",
      };
    }
    setErrors(validationErrors);
    if (Object.keys(validationErrors).length === 0) {
      dispatch(changeLoader(true));
      if (auth?.id) {
        try {
          let response = await globalRequest(
            Number(getAddress?.id) < 1
              ? USERS?.ADD_ADDRESS
              : USERS?.UPDATE_ADDRESS,
            Number(getAddress?.id) < 1 ? "post" : "put",
            {
              ...getAddress,
              address: getAddress?.street_address || "",
              address_details: getAddress?.addressDetails || "",
            },
            {},
            true
          );
          response = response?.data;
          dispatch(changeLoader(false));
          if (response?.status !== "SUCCESS") {
            dispatch(
              setSnackbar({
                snackbarOpen: true,
                snackbarMessage: response?.message,
                snackbarState: "error",
              })
            );
            return;
          }
          closepopupout("getAddressList");
          dispatch(
            setSnackbar({
              snackbarOpen: true,
              snackbarMessage: response?.message,
              snackbarState: "success",
            })
          );
        } catch (e) {
          dispatch(
            setSnackbar({
              snackbarOpen: true,
              snackbarMessage: e?.message,
              snackbarState: "error",
            })
          );
        }
      } else {
        let addguest = {
          ...getAddress,
          address: getAddress?.street_address || "",
          address_details: getAddress?.address || "",
        };
        addguest.guest_id = CUSTOM.getDeviceID();
        if (pageName == "cart") {
          try {
            let response = await globalRequest(
              GUEST?.ADD_ADDRESS,
              "post",
              addguest,
              {},
              true
            );
            response = response?.data;
            dispatch(changeLoader(false));
            if (response?.status !== "SUCCESS") {
              dispatch(
                setSnackbar({
                  snackbarOpen: true,
                  snackbarMessage: response?.message,
                  snackbarState: "error",
                })
              );
            } else {
              closepopupout("getAddressList");
              addDeleteGetLocalStorage(
                storageKeys.GUEST_ADDRESS,
                {
                  ...getAddress,
                  address: getAddress?.street_address || "",
                  address_details: getAddress?.address || "",
                },
                "add",
                "single"
              );
            }
          } catch (e) {
            dispatch(
              setSnackbar({
                snackbarOpen: true,
                snackbarMessage: e?.message,
                snackbarState: "error",
              })
            );
          }
        } else {
          try {
            // let response = await globalRequest(
            //   GUEST?.ADD_ADDRESS,
            //   "post",
            //   {
            //     ...addguest,
            //     guest_id: CUSTOM.getDeviceID(),
            //     full_name: getAddress?.full_name ? getAddress?.full_name : "",
            //     mobile_no: getAddress?.mobile_no ? getAddress?.mobile_no : "",
            //   },
            //   {},
            //   true
            // );
            let response = await globalRequest(
              ADDRESS.CHECK_ADDRESS,
              "post",
              addguest,
              {},
              true
            );
            response = response?.data;
            dispatch(changeLoader(false));
            if (response?.status !== "SUCCESS") {
              dispatch(
                setSnackbar({
                  snackbarOpen: true,
                  snackbarMessage: response?.message,
                  snackbarState: "error",
                })
              );
              return;
            }
          } catch (e) {
            dispatch(
              setSnackbar({
                snackbarOpen: true,
                snackbarMessage: e?.message,
                snackbarState: "error",
              })
            );
            return;
          }
          addDeleteGetLocalStorage(
            storageKeys.GUEST_ADDRESS,
            {
              ...getAddress,
              address: getAddress?.address || "",
              address_details: getAddress?.street_address || "",
            },
            "add",
            "single"
          );
          closepopupout(false);
        }
      }
      dispatch(changeLoader(false));
    }
  };

  useEffect(() => {
    if (auth?.id == 0) {
      let dAddress = defaultAddressParams();
      try {
        let addressData = addDeleteGetLocalStorage(
          storageKeys.GUEST_ADDRESS,
          {},
          "get"
        );
        if (addressData) {
          dAddress = JSON.parse(addressData);
        }
      } catch (e) {}
      dispatch(
        updateMyAddress({
          ...dAddress,
          current_location_distance: null,
          location_verified: false,
        })
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (pageName == "cart") {
      if (orderData?.userDetails?.first_name) {
        dispatch(
          updateMyAddress({
            ...getAddress,
            full_name: strFormat(
              `${orderData?.userDetails?.first_name} ${orderData?.userDetails?.last_name}`,
              "max:50|text"
            ),
            mobile_no: orderData?.userDetails?.mobile_no,
          })
        );
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (isInlineMode && pageName === "cart") {
    return (
      <div className="w-full bg-[white] rounded-xl p-6 shadow-sm sm:p-0">
        <div className="w-full mb-6 rounded-xl overflow-hidden ">
          <AutoFillAddress></AutoFillAddress>
        </div>
        {!getAddress?.location_verified ? (
          <div className="w-full mb-2">
            <Text className={`text-[13px] font-normal text-[#6D737E] ${interClass}`}>
              {t("yourCurrentLocationIsOff")}
            </Text>
          </div>
        ) : (
          getAddress?.current_location_distance !== undefined &&
          getAddress?.current_location_distance !== null && (
            <div className="w-full mb-2">
              <Text className={`text-[13px] font-normal text-[#6D737E] ${interClass}`}>
                {getAddress.current_location_distance < 1
                  ? `${Math.round(getAddress.current_location_distance * 1000)} m from your current location`
                  : `${getAddress.current_location_distance.toFixed(2)} km from your current location`}
              </Text>
            </div>
          )
        )}
        {(getAddress?.street_address || getAddress?.formatted_address || getAddress?.address) && (
          <div className="flex flex-row items-start gap-2 mb-4 px-1">
            <Img src="/images/location_on_black.svg" className="h-4 w-4 mt-0.5 flex-shrink-0" alt="loc" />
            <span className={`text-sm text-gray-700 font-medium ${interClass} leading-relaxed`}>
              {getAddress?.street_address || getAddress?.formatted_address || getAddress?.address}
            </span>
          </div>
        )}
        <div className="w-full mb-4">
          <Text className={`text-[20px] leading-[28px] font-semibold text-[#1A1A1A] ${interClass} sm:text-[16px] sm:leading-[24px] sm:font-medium`}>
            {t("addressInformation")}
          </Text>
        </div>

        <form id="addressForm" className="w-full" onSubmit={saveAddress}>
          <div className="w-full mb-4">
            <label className={`block mb-1 text-[14px] font-normal text-[#6D737E] ${interClass}`}>
              {t("addressLabel")} *
            </label>
            <Input
              className={`w-full ${interClass}`}
              placeholder={t("addressPlaceholder")}
              error={errors?.addressDetails}
              value={getAddress?.addressDetails || ""}
              onChange={(e) => {
                setErrors({ ...errors, addressDetails: "" });
                dispatch(
                  updateMyAddress({
                    ...getAddress,
                    addressDetails: strFormat(e.target.value, "max:100"),
                  })
                );
              }}
            />
          </div>

          {/* Street Address input - moved to single line display above
          <div className="w-full">
            <label className={`block mb-1 text-[14px] font-normal text-[#6D737E] ${interClass}`}>
               {t("streetAddress")} *
            </label>
            <Input
              className={`w-full figma-input font-[14px] ${interClass} font-medium`}
              placeholder={t("enterStreetAddress")}
              error={errors?.street_address}
              value={getAddress?.street_address || ""}
              // onChange={(e) => {
              //   setErrors({ ...errors, street_address: "" });
              //   dispatch(
              //     updateMyAddress({
              //       ...getAddress,
              //       street_address: strFormat(e.target.value, "max:100"),
              //     })
              //   );
              // }}
              readOnly
              // disabled={true}
            />
          </div>
          */}

          <div className="w-full mb-4">
            <label className={`block mb-1 text-[14px] font-normal text-[#6D737E] ${interClass}`}>
              {t("streetNumber")} *
            </label>
            <Input
              className={`w-full figma-input ${interClass}`}
              placeholder={t("enterStreetNumber")}
              error={errors?.street_number}
              value={getAddress?.street_number || ""}
              onChange={(e) => {
                setErrors({ ...errors, street_number: "" });
                dispatch(
                  updateMyAddress({
                    ...getAddress,
                    street_number: strFormat(e.target.value, "max:50"),
                  })
                );
              }}
            />
          </div>

          <div className="grid grid-cols-2 gap-4 w-full sm:grid-cols-1">
            <div>
              <label className={`block mb-1 text-[14px] font-normal text-[#6D737E] ${interClass}`}>
                {t("buildingNumber")} *
              </label>
              <Input
                className={`w-full figma-input ${interClass}`}
                placeholder={t("enterBuildingNumber")}
                error={errors?.building_number}
                value={getAddress?.building_number || ""}
                onChange={(e) => {
                  setErrors({ ...errors, building_number: "" });
                  dispatch(
                    updateMyAddress({
                      ...getAddress,
                      building_number: strFormat(e.target.value, "max:50"),
                    })
                  );
                }}
              />
            </div>

            <div>
              <label className={`block mb-1 text-[14px] font-normal text-[#6D737E] ${interClass}`}>
                {t("floor_Apartment")} *
              </label>
              <Input
                className={`w-full ${interClass}`}
                placeholder={t("enterFloorNumber")}
                error={errors?.floor_apartment}
                value={getAddress?.floor_apartment || ""}
                onChange={(e) => {
                  setErrors({ ...errors, floor_apartment: "" });
                  dispatch(
                    updateMyAddress({
                      ...getAddress,
                      floor_apartment: strFormat(e.target.value, "max:50"),
                    })
                  );
                }}
              />
            </div>
          </div>


          {/* Full Name and Mobile - Only show if authenticated - Commented out as per image
          {auth?.id && pageName != "topHeader" ? (
            <div className="grid grid-cols-2 gap-4 mb-6 sm:grid-cols-1">
              <Input
                className="w-full"
                label={`${t("fullname")}*`}
                error={errors?.full_name}
                value={getAddress?.full_name}
                onChange={(e) => {
                  setErrors({ ...errors, full_name: "" });
                  dispatch(
                    updateMyAddress({
                      ...getAddress,
                      full_name: strFormat(e.target.value, "max:50|text"),
                    })
                  );
                }}
              />
              <MobileInput
                className="w-full"
                label={`${t("mobile")}*`}
                error={errors?.mobile_no}
                value={getAddress?.mobile_no}
                onChange={(e) => {
                  setErrors({ ...errors, mobile_no: "" });
                  dispatch(
                    updateMyAddress({
                      ...getAddress,
                      mobile_no: strFormat(e.target.value, "max:9|number"),
                    })
                  );
                }}
              />
            </div>
          ) : null}
          */}

          {/* Image Upload */}
          <div className="w-full mb-6">
            <label className={`block mb-2 text-[14px] font-normal text-[#6D737E] ${interClass}`}>
              {t("addressImage")}
            </label>
            <div className="flex items-center gap-4">
              {getAddress?.image_link && (
                <div className="relative w-24 h-24 rounded-lg overflow-hidden border border-gray-200">
                  <Img
                    src={CUSTOM.getImage(getAddress?.image_link)}
                    className="w-full h-full object-cover"
                    alt="Address Image"
                  />
                  <button
                    type="button"
                    className="absolute top-1 right-1 bg-white rounded-full p-1 shadow-sm"
                    onClick={() => dispatch(updateMyAddress({ ...getAddress, image_link: "" }))}
                  >
                    <Img src="/images/img_close_gray_700.svg" className="h-3 w-3" alt="remove" />
                  </button>
                </div>
              )}
              <div 
                className="flex flex-col items-center justify-center w-24 h-24 rounded-lg border-2 border-dashed border-gray-300 cursor-pointer hover:bg-gray-50"
                onClick={() => document.getElementById("address-image-upload").click()}
              >
                <Img src="/images/img_upload.svg" className="h-6 w-6 mb-1 text-gray-400" alt="upload" />
                <span className="text-[10px] text-gray-500">{t("upload")}</span>
              </div>
              <input
                type="file"
                id="address-image-upload"
                className="hidden"
                accept="image/png, image/jpeg, image/jpg"
                onChange={handleImageChange}
              />
            </div>
          </div>

          {/* Buttons */}
          <div className="flex gap-3 w-full">
            <Button
              className={`w-1/2 h-[48px] rounded-full border-2 border-gray-300 text-gray-700 text-[14px] ${interClass} font-medium hover:border-gray-400`}
              size="lg"
              variant="OutlineBlack"
              type="button"
              onClick={() => closepopupout("noAction")}
            >
              {t("cancel")}
            </Button>
            <Button
              className={`w-1/2 h-[48px] rounded-full bg-[#771237] hover:bg-[#8B1543] text-white text-[14px] font-medium ${headingClass}`}
              size="lg"
              variant="FillBlack"
              type="submit"
              disabled={ !getAddress?.street_address && !getAddress?.formatted_address && !getAddress?.address}
            >
              {t("saveAndContinue")}
            </Button>
          </div>
        </form>
      </div>
    );
  }

  return (
    <>
      {Object.keys(getAddress).length > 0 ? (
        <>
          <div className="all-popup-class justify-center items-start flex overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none pt-8 sm:pt-0">
            <div className="relative w-auto my-6 md:my-0 mx-auto max-w-[900px] min-w-[900px] lg:max-w-[700px] lg:min-w-[700px] sm:w-full sm:min-w-full sm:max-w-full overflow-hidden">
              {/*content*/}
              <div className="border-0 rounded-2xl md:rounded-b-none relative flex flex-col w-full bg-[white] outline-none focus:outline-none overflow-hidden sm:rounded-none">
                
                {/* Header - Desktop Only */}
                <div className="flex items-center justify-between px-6 py-5 border-b border-gray-200 sm:hidden">
                  <Text className={`text-[20px] font-semibold text-black-900 ${interClass}`}>
                    {t("myAddresses")}
                  </Text>
                  <button
                    onClick={() => closepopupout("noAction")}
                    className="p-1 hover:bg-gray-100 rounded-full transition-colors"
                  >
                    <Img
                      src="/images/img_close_gray_700.svg"
                      className="h-5 w-5"
                      alt="close"
                    />
                  </button>
                </div>

                {/*body*/}
                <div className="flex w-full sm:flex-col">
                  
                  {/* Left Side - Map */}
                  <div className="w-1/2 sm:w-full bg-gray-50 sm:h-[300px]">
                    <div className="w-full h-full">
                      <AutoFillAddress></AutoFillAddress>
                    </div>
                  </div>

                  {/* Right Side - Form */}
                  <div className="w-1/2 sm:w-full p-6 sm:p-4 overflow-auto max-h-[80vh] sm:max-h-none">
                    
                    {/* Search Input */}
                    {/* <div className="w-full mb-6">
                      <div className="relative">
                        <Img
                          src="/images/img_search.svg"
                          className="absolute left-3 top-1/2 transform -translate-y-1/2 h-5 w-5 text-gray-400"
                          alt="search"
                        />
                        <input
                          type="text"
                          placeholder={t("searchForLocations")}
                          className="w-full pl-10 pr-4 py-3 border border-gray-300 rounded-lg text-sm text-gray-700 placeholder-gray-400 focus:outline-none focus:border-gray-400"
                        />
                      </div>
                    </div> */}
                    {!getAddress?.location_verified ? (
                      <div className="w-full mb-2">
                        <Text className={`text-[13px] font-normal text-[#6D737E] ${interClass}`}>
                          {t("yourCurrentLocationIsOff")}
                        </Text>
                      </div>
                    ) : (
                      getAddress?.current_location_distance !== undefined &&
                      getAddress?.current_location_distance !== null && (
                        <div className="w-full mb-2">
                          <Text className={`text-[13px] font-normal text-[#6D737E] ${interClass}`}>
                            {getAddress.current_location_distance < 1
                              ? `${Math.round(getAddress.current_location_distance * 1000)} m from your current location`
                              : `${getAddress.current_location_distance.toFixed(2)} km from your current location`}
                          </Text>
                        </div>
                      )
                    )}

                    {(getAddress?.street_address || getAddress?.formatted_address) && (
                      <div className="flex flex-row items-start gap-2 mb-4 px-1">
                        <Img src="/images/location_on_black.svg" className="h-4 w-4 mt-0.5 flex-shrink-0" alt="loc" />
                        <span className={`text-sm text-gray-700 font-medium ${interClass} leading-relaxed`}>
                          {getAddress?.street_address || getAddress?.formatted_address}
                        </span>
                      </div>
                    )}

                    <form id="addressForm" className="w-full" onSubmit={saveAddress}>
                      
                      {/* Address Label */}
                      <div className="w-full mb-4">
                        <label className={`block mb-2 text-[13px] font-medium text-gray-700 ${interClass}`}>
                          {t("addressLabel")} *
                        </label>
                        <Input
                          className="w-full"
                          placeholder={t("addressPlaceholder")}
                          error={errors?.addressDetails}
                          value={getAddress?.addressDetails || ""}
                          onChange={(e) => {
                            setErrors({ ...errors, addressDetails: "" });
                            dispatch(
                              updateMyAddress({
                                ...getAddress,
                                addressDetails: strFormat(e.target.value, "max:100"),
                              })
                            );
                          }}
                        />
                      </div>

                      {/* Street Address - moved to single line display above
                      <div className="w-full mb-4">
                        <label className={`block mb-2 text-[13px] font-medium text-gray-700 ${interClass}`}>
                         {t("streetAddress")} *
                        </label>
                        <Input
                          className="w-full"
                          placeholder={t("enterStreetAddress")}
                          error={errors?.street_address}
                          value={getAddress?.street_address || ""}
                          onChange={(e) => {
                            setErrors({ ...errors, street_address: "" });
                            dispatch(
                              updateMyAddress({
                                ...getAddress,
                                street_address: strFormat(e.target.value, "max:100"),
                              })
                            );
                          }}
                        />
                      </div>
                      */}

                      {/* Street Number */}
                      <div className="w-full mb-4">
                        <label className={`block mb-2 text-[13px] font-medium text-gray-700 ${interClass}`}>
                        {t("streetNumber")} *
                        </label>
                        <Input
                          className="w-full"
                          placeholder={t("enterStreetNumber")}
                          error={errors?.street_number}
                          value={getAddress?.street_number || ""}
                          onChange={(e) => {
                            setErrors({ ...errors, street_number: "" });
                            dispatch(
                              updateMyAddress({
                                ...getAddress,
                                street_number: strFormat(e.target.value, "max:50"),
                              })
                            );
                          }}
                        />
                      </div>

                      {/* Building Number */}
                      <div className="w-full mb-4">
                        <label className={`block mb-2 text-[13px] font-medium text-gray-700 ${interClass}`}>
                        {t("buildingNumber")} *
                        </label>
                        <Input
                          className="w-full"
                          placeholder={t("enterBuildingNumber")}
                          error={errors?.building_number}
                          value={getAddress?.building_number || ""}
                          onChange={(e) => {
                            setErrors({ ...errors, building_number: "" });
                            dispatch(
                              updateMyAddress({
                                ...getAddress,
                                building_number: strFormat(e.target.value, "max:50"),
                              })
                            );
                          }}
                        />
                      </div>

                      {/* Floor/Apartment Number */}
                      <div className="w-full mb-6">
                        <label className={`block mb-2 text-[13px] font-medium text-gray-700 ${interClass}`}>
                         {t("floor_Apartment")} *
                        </label>
                        <Input
                          className="w-full"
                          placeholder={t("enterFloorNumber")}
                          error={errors?.floor_apartment}
                          value={getAddress?.floor_apartment || ""}
                          onChange={(e) => {
                            setErrors({ ...errors, floor_apartment: "" });
                            dispatch(
                              updateMyAddress({
                                ...getAddress,
                                floor_apartment: strFormat(e.target.value, "max:50"),
                              })
                            );
                          }}
                        />
                      </div>

                      {/* Full Name and Mobile - Only show if authenticated - Commented out as per image
                      {auth?.id && pageName != "topHeader" ? (
                        <div className="grid grid-cols-2 gap-4 mb-6 sm:grid-cols-1">
                          <Input
                            className="w-full"
                            label={`${t("fullname")}*`}
                            error={errors?.full_name}
                            value={getAddress?.full_name}
                            onChange={(e) => {
                              setErrors({ ...errors, full_name: "" });
                              dispatch(
                                updateMyAddress({
                                  ...getAddress,
                                  full_name: strFormat(e.target.value, "max:50|text"),
                                })
                              );
                            }}
                          />
                          <MobileInput
                            className="w-full"
                            label={`${t("mobile")}*`}
                            error={errors?.mobile_no}
                            value={getAddress?.mobile_no}
                            onChange={(e) => {
                              setErrors({ ...errors, mobile_no: "" });
                              dispatch(
                                updateMyAddress({
                                  ...getAddress,
                                  mobile_no: strFormat(e.target.value, "max:9|number"),
                                })
                              );
                            }}
                          />
                        </div>
                      ) : null}
                      */}

                      {/* Image Upload */}
                      <div className="w-full mb-6">
                        <label className={`block mb-2 text-[13px] font-medium text-gray-700 ${interClass}`}>
                          {t("addressImage")} 
                        </label>
                        <div className="flex items-center gap-4">
                          {getAddress?.image_link && (
                            <div className="relative w-24 h-24 rounded-lg overflow-hidden border border-gray-200">
                              <Img
                                src={CUSTOM.getImage(getAddress?.image_link)}
                                className="w-full h-full object-cover"
                                alt="Address Image"
                              />
                              <button
                                type="button"
                                className="absolute top-1 right-1 bg-white rounded-full p-1 shadow-sm"
                                onClick={() => dispatch(updateMyAddress({ ...getAddress, image_link: "" }))}
                              >
                                <Img src="/images/img_close_gray_700.svg" className="h-3 w-3" alt="remove" />
                              </button>
                            </div>
                          )}
                          <div 
                            className="flex flex-col items-center justify-center w-24 h-24 rounded-lg border-2 border-dashed border-gray-300 cursor-pointer hover:bg-gray-50"
                            onClick={() => document.getElementById("address-image-upload-popup").click()}
                          >
                            <Img src="/images/img_upload.svg" className="h-6 w-6 mb-1 text-gray-400" alt="upload" />
                            <span className="text-[10px] text-gray-500">Upload</span>
                          </div>
                          <input
                            type="file"
                            id="address-image-upload-popup"
                            className="hidden"
                            accept="image/png, image/jpeg, image/jpg"
                            onChange={handleImageChange}
                          />
                        </div>
                      </div>

                      {/* Save Button */}
                      <div className="w-full">
                        <Button
                          className={`w-full h-[50px] rounded-full bg-[#7A2C4E] hover:bg-[#8B1543] text-white text-[15px] font-medium ${interClass}`}
                          size="lg"
                          variant="FillBlack"
                          type="submit"
                          disabled={ !getAddress?.street_address && !getAddress?.formatted_address && !getAddress?.address}
                        >
                          {t("saveNewAddress")}
                        </Button>
                      </div>

                      {/* Cancel Button - Hidden on desktop, visible on mobile
                      <Button
                        className="w-full hidden sm:block sm:py-1 sm:h-10 mt-3"
                        size="md"
                        type="button"
                        variant="OutlineBlack"
                        onClick={() => closepopupout(false)}
                      >
                        {t("cancel")}
                      </Button>
                      */}
                    </form>
                  </div>
                </div>

                {/* Unused old code - keeping for reference
                <div className="flex flex-row items-center justify-end w-full px-6 pt-4 pb-2 sm:hidden">
                  <div className="flex flex-row items-start justify-end w-auto">
                    <Img
                      src="/images/img_close_gray_700.svg"
                      className="common-pointer h-4 w-4"
                      alt="close"
                      onClick={() => closepopupout("noAction")}
                    />
                  </div>
                </div>
                */}

                {/* Unused old body layout - keeping for reference
                <div className="flex flex-col items-start justify-start w-full px-6 pb-6 sm:px-4 overflow-auto">
                  
                  <div className="w-full mb-6 rounded-xl overflow-hidden h-[450px] sm:h-[350px]">
                    <AutoFillAddress></AutoFillAddress>
                  </div>

                  <div className="w-full mb-4">
                    <Text className={`text-[20px] leading-[28px] font-semibold text-[#1A1A1A] ${interClass}`}>
                      {t("addressInformation")}
                    </Text>
                  </div>
                </div>
                */}
              </div>
            </div>
          </div>
          <div
            className="opacity-50 fixed inset-0 z-40 bg-gray-500 backdrop-blur-sm"
            onClick={() => closepopupout("noAction")}
          ></div>
        </>
      ) : null}
    </>
  );
};
export { AddEditAddress };